<div *ngIf="init" class="d-flex">
  <selector
    class="first-form-field"
    [subtitle]="displayProjectContact"
    [subtitleWidth]="'275px'"
    [options]="numbers"
    [optionPipe]="formatPhoneNumber"
    (answerChange)="productPhoneNumberChange($event)"
    [answer]="productPhoneNumber.phoneNumbers"
  ></selector>
  <div class="form-field">
    <div class="subtitle">Alternatief telefoonnummer</div>
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Alternatief telefoonnummer"
        name="alternatePhoneNumber"
        [ngModel]="
          alternateProductPhoneNumber.phoneNumbers | asFormatPhoneNumber
        "
        (ngModelChange)="alternateProductPhoneNumberChange($event)"
      />
    </mat-form-field>
  </div>
</div>
